var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: { "append-to-body": "", visible: _vm.dialogVisible, width: "90%" },
      on: {
        close: _vm.close,
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "lineBox" }, [
          _c("div", { staticClass: "lineBoxTitle" }, [
            _c("div", { staticClass: "fengGe" }),
            _c("p", { staticClass: "p1" }, [_vm._v("开票说明")]),
            _c("p", { staticClass: "p2" }, [
              _vm._v("该订单由麦格仕(或其分公司)开发票"),
            ]),
          ]),
          _c("p", { staticClass: "lineBoxP1" }, [
            _c("span", { staticClass: "lineBoxSpan1" }, [_vm._v("*")]),
            _vm._v("可发票金额 "),
            _c("span", { staticClass: "lineBoxSpan2" }, [
              _vm._v("不包含礼品卡 优惠劵 积分抵扣"),
            ]),
            _vm._v(" 支付的部分"),
          ]),
          _c("p", { staticClass: "lineBoxP1" }, [
            _c("span", { staticClass: "lineBoxSpan1" }, [_vm._v("*")]),
            _vm._v(
              "该房费发票由麦格仕(或其分公司)开具。保险发票由保险公司开具并在离店后 7个工作日左右寄达给您。 "
            ),
          ]),
          _c("p", { staticClass: "lineBoxP1" }, [
            _c("span", { staticClass: "lineBoxSpan1" }, [_vm._v("*")]),
            _vm._v(
              '您的订单包含附加产品时，订单升级为旅游套餐订单，开票内容统一为"旅游服务 旅游服务费"。'
            ),
          ]),
        ]),
        _c(
          "div",
          {
            staticClass: "lineBox",
            staticStyle: { "margin-bottom": "0.7rem" },
          },
          [
            _c("div", { staticClass: "lineBoxTitle" }, [
              _c("div", { staticClass: "fengGe" }),
              _c("p", { staticClass: "p1" }, [
                _vm._v("可以开具哪些类型的发票？"),
              ]),
              _c("p", { staticClass: "p2" }, [_vm._v("发票类型及介绍")]),
            ]),
            _vm._l(_vm.invoiceTypeObj, function (item, keys) {
              return _c(
                "div",
                { key: keys, staticClass: "invoice" },
                _vm._l(item.lineList, function (n, m) {
                  return _c(
                    "div",
                    { key: m, staticClass: "invoiceBox", style: item.sty },
                    [_vm._v(" " + _vm._s(n) + " ")]
                  )
                }),
                0
              )
            }),
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "lineBox" },
          [
            _c(
              "div",
              { staticClass: "lineBoxTitle" },
              [
                _c("div", { staticClass: "fengGe" }),
                _c("p", { staticClass: "p1" }, [_vm._v("发票信息")]),
                _vm._l(_vm.invoiceInfoBtn, function (item, index) {
                  return _c(
                    "p",
                    {
                      key: item,
                      staticClass: "p3",
                      class: _vm.current === item ? "active" : "",
                      on: {
                        click: function ($event) {
                          ;(_vm.current = item),
                            (_vm.ruleForm.invoicingKind = index),
                            (_vm.ruleForm.invoicingType = 0),
                            _vm.invoiceTypeSW()
                        },
                      },
                    },
                    [_vm._v(_vm._s(item))]
                  )
                }),
              ],
              2
            ),
            _c(
              "el-card",
              { staticClass: "box-card" },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-bottom": "10px",
                      display: "flex",
                      "align-items": "center",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "font-size": "20px",
                          "font-weight": "bold",
                          color: "red",
                        },
                      },
                      [
                        _vm._v(
                          "开票金额：" +
                            _vm._s(
                              _vm.current == "合并开票"
                                ? _vm.allOrderPrice
                                : _vm.spreadDatas.payPrice
                            ) +
                            "¥ "
                        ),
                      ]
                    ),
                    _vm.tableData.length
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "margin-left": "0.2rem",
                              "font-size": "0.17rem",
                              cursor: "pointer",
                              "text-decoration": "underline",
                              color: "#CB582E",
                            },
                            on: { click: _vm.selectInvoiceInfo },
                          },
                          [_vm._v("选择已有数据")]
                        )
                      : _vm._e(),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "cardLine" },
                  [
                    _c("p", { staticClass: "cardLineP1" }, [
                      _c("span", [_vm._v("*")]),
                      _vm._v("发票类型："),
                    ]),
                    _vm._l(_vm.cardLineBtn, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "infoBox",
                          class:
                            _vm.ruleForm.invoicingType == item.code
                              ? "active1"
                              : "",
                          on: {
                            click: function ($event) {
                              _vm.ruleForm.invoicingType = item.code
                            },
                          },
                        },
                        [
                          _c("p", [_vm._v(_vm._s(item.name))]),
                          _c("p", [_vm._v(_vm._s(item.name1))]),
                        ]
                      )
                    }),
                  ],
                  2
                ),
                _c(
                  "el-form",
                  {
                    ref: "ruleForm",
                    staticClass: "demo-ruleForm",
                    attrs: {
                      model: _vm.ruleForm,
                      rules: _vm.rules,
                      "label-width": "90px",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "发票方:", prop: "invoicingPartyName" },
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "2.4rem" },
                          attrs: {
                            disabled: "",
                            placeholder: "请输入内容",
                            size: "small",
                          },
                          model: {
                            value: _vm.ruleForm.invoicingPartyName,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "invoicingPartyName", $$v)
                            },
                            expression: "ruleForm.invoicingPartyName",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._l(
                      _vm.ruleForm.invoicingDetailList,
                      function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                            },
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "发票内容:", required: "" } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "lookUp" } },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "2.4rem" },
                                      attrs: {
                                        placeholder: "请输入发票内容",
                                        size: "small",
                                      },
                                      model: {
                                        value: item.remark,
                                        callback: function ($$v) {
                                          _vm.$set(item, "remark", $$v)
                                        },
                                        expression: "item.remark",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: "发票类型:", required: "" } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "type" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "2.5rem" },
                                        attrs: {
                                          size: "small",
                                          placeholder: "请选择",
                                        },
                                        model: {
                                          value: item.type,
                                          callback: function ($$v) {
                                            _vm.$set(item, "type", $$v)
                                          },
                                          expression: "item.type",
                                        },
                                      },
                                      _vm._l(_vm.options, function (item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: "发票抬头:", required: "" } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "lookUp" } },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "2.4rem" },
                                      attrs: {
                                        placeholder: "公司名称",
                                        size: "small",
                                      },
                                      model: {
                                        value: item.lookUp,
                                        callback: function ($$v) {
                                          _vm.$set(item, "lookUp", $$v)
                                        },
                                        expression: "item.lookUp",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: "税号:", required: "" } },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: {
                                        width: "2.4rem",
                                        "margin-right": "0.08rem",
                                      },
                                      attrs: {
                                        placeholder: "纳税人识别号",
                                        size: "small",
                                      },
                                      model: {
                                        value: item.duty,
                                        callback: function ($$v) {
                                          _vm.$set(item, "duty", $$v)
                                        },
                                        expression: "item.duty",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "margin-left": "0.1rem",
                                  color: "red",
                                  "margin-bottom": "0.22rem",
                                },
                              },
                              [
                                _vm._v(
                                  "分项金额:" + _vm._s(Number(item.price)) + "¥"
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      }
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "邮箱地址:", prop: "email" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "2.4rem" },
                              attrs: { placeholder: "邮箱地址", size: "small" },
                              model: {
                                value: _vm.ruleForm.email,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "email", $$v)
                                },
                                expression: "ruleForm.email",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "地址:" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "2.4rem" },
                              attrs: {
                                placeholder: "请输入地址",
                                size: "small",
                              },
                              model: {
                                value: _vm.ruleForm.address,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "address", $$v)
                                },
                                expression: "ruleForm.address",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "电话:" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "2.4rem" },
                              attrs: {
                                placeholder: "请输入电话",
                                size: "small",
                              },
                              model: {
                                value: _vm.ruleForm.telephone,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "telephone", $$v)
                                },
                                expression: "ruleForm.telephone",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "开户行:" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "2.4rem" },
                              attrs: {
                                placeholder: "请输入开户行",
                                size: "small",
                              },
                              model: {
                                value: _vm.ruleForm.openingBank,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "openingBank", $$v)
                                },
                                expression: "ruleForm.openingBank",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "账号:" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "2.4rem" },
                              attrs: {
                                placeholder: "请输入账号",
                                size: "small",
                              },
                              model: {
                                value: _vm.ruleForm.openingBankAccount,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ruleForm,
                                    "openingBankAccount",
                                    $$v
                                  )
                                },
                                expression: "ruleForm.openingBankAccount",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "发票备注:" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "2.4rem" },
                              attrs: {
                                placeholder: "发票注明酒店名和入离日期",
                                size: "small",
                              },
                              model: {
                                value: _vm.ruleForm.invoicingRemark,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "invoicingRemark", $$v)
                                },
                                expression: "ruleForm.invoicingRemark",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.current == "合并开票"
                      ? _c("div", { staticClass: "cardLine" }, [
                          _c(
                            "p",
                            {
                              staticClass: "cardLineP1",
                              staticStyle: {
                                width: "1.5rem",
                                "margin-right": "0.2rem",
                              },
                            },
                            [
                              _c("span", [_vm._v("*")]),
                              _vm._v("同张发票，含 "),
                              _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.ruleForm.invoicingOrderPriceRequests
                                      .length
                                  )
                                ),
                              ]),
                              _vm._v(" 个订单 "),
                            ]
                          ),
                          _c(
                            "p",
                            {
                              staticClass: "cardLineP2",
                              on: { click: _vm.handlerSelectOrderClick },
                            },
                            [_vm._v("修 改")]
                          ),
                        ])
                      : _vm._e(),
                    _vm.current == "拆分开票"
                      ? _c(
                          "div",
                          {
                            staticClass: "cardLine",
                            staticStyle: {
                              display: "inline-flex",
                              "flex-direction": "column",
                            },
                          },
                          [
                            _c("div", { staticStyle: { display: "flex" } }, [
                              _c(
                                "p",
                                {
                                  staticClass: "cardLineP1",
                                  staticStyle: {
                                    width: "1.5rem",
                                    "margin-right": "0.2rem",
                                  },
                                },
                                [
                                  _c("span", [_vm._v("*")]),
                                  _vm._v("设置开票数量："),
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          this.ruleForm.invoicingDetailList
                                            .length
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v("张 "),
                                ]
                              ),
                              _c(
                                "p",
                                {
                                  staticClass: "cardLineP2",
                                  on: {
                                    click: _vm.handlerSetOrderInvoiceClick,
                                  },
                                },
                                [_vm._v("设 置")]
                              ),
                            ]),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "margin-top": "3px",
                                  "margin-left": "2px",
                                },
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass: "cardLineP1",
                                    staticStyle: {
                                      width: "1.5rem",
                                      "margin-right": "0.2rem",
                                    },
                                  },
                                  [
                                    _c("span", [_vm._v("*")]),
                                    _vm._v("同张发票，含 "),
                                    _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.ruleForm
                                              .invoicingOrderPriceRequests
                                              .length
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" 个订单 "),
                                  ]
                                ),
                                _c(
                                  "p",
                                  {
                                    staticClass: "cardLineP2",
                                    on: { click: _vm.handlerSelectOrderClick },
                                  },
                                  [_vm._v("修 改")]
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.ruleForm.invoicingType != 0
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "收票人信息:", required: "" } },
                          [
                            _c("el-form-item", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    cursor: "pointer",
                                    "text-decoration": "underline",
                                    "margin-right": "0.2rem",
                                  },
                                  on: { click: _vm.addressFilling },
                                },
                                [_vm._v("添加新地址")]
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    cursor: "pointer",
                                    "text-decoration": "underline",
                                  },
                                  on: { click: _vm.selectAddress },
                                },
                                [_vm._v("选择已有地址")]
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    JSON.stringify(_vm.addressInfo) !== "{}" &&
                    _vm.ruleForm.invoicingType != 0
                      ? _c(
                          "el-card",
                          {
                            staticStyle: {
                              "margin-bottom": "0.15rem",
                              width: "4rem",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "clearfix",
                                attrs: { slot: "header" },
                                slot: "header",
                              },
                              [_c("span", [_vm._v("收件人详细信息")])]
                            ),
                            _c("ul", { staticClass: "addressInfoBox" }, [
                              _c("li", [
                                _c("p", [_vm._v("姓名：")]),
                                _vm._v(_vm._s(_vm.addressInfo.userName) + " "),
                              ]),
                              _c("li", [
                                _c("p", [_vm._v("手机号码：")]),
                                _vm._v(_vm._s(_vm.addressInfo.userPhone) + " "),
                              ]),
                              _c("li", [
                                _c("p", [_vm._v("收货地址：")]),
                                _vm._v(_vm._s(_vm.addressInfo.address) + " "),
                              ]),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.submitForm("ruleForm")
                              },
                            },
                          },
                          [_vm._v("保存发票信息")]
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("orderSelectList", {
        ref: "orderSelectList",
        attrs: { defaultGou: _vm.spreadDatas.orderMainId },
        on: { orderClick: _vm.orderClick },
      }),
      _c("collectionSelectList", {
        ref: "collectionSelectList",
        attrs: { defaultGou: _vm.spreadDatas.orderMainId },
        on: { orderClick: _vm.orderClick },
      }),
      _c("setInvoicePopup", {
        ref: "setInvoicePopup",
        attrs: { planId: _vm.planId, tableData: _vm.tableData },
        on: { setInvoiceClick: _vm.setInvoiceClick },
      }),
      _c("ticketRecipientInformationPopup", {
        ref: "ticketRecipientInfo",
        on: { addressInfoClick: _vm.addressInfoClick },
      }),
      _c("existingAddressPopup", {
        ref: "existingAddressPopup",
        on: { addressInfoClick: _vm.addressInfoClick },
      }),
      _c("thereIsAlreadyAnInvoicePopUpBox", {
        ref: "thereIsAlreadyAnInvoicePopUpBox",
        attrs: { tableData: _vm.tableData, planId: _vm.planId },
        on: { selectInvoice: _vm.selectInvoice },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }